import { useQuery } from '@tanstack/react-query'
import { ChallengeService } from '@duck/api-definitions'
import { apis } from '@/modules/apiClients'

export const selectFirstChallenge = (
  items: ChallengeService.ChallengeInfo[],
): ChallengeService.ChallengeInfo | undefined => {
  if (items.length > 1) {
    console.warn('useAdminChallenge: multiple challenges matched slug; using first', { count: items.length })
  }
  return items[0]
}

export const adminChallengeQueryKey = (slug: string) => ['admin-challenge', slug] as const

export const useAdminChallenge = (slug: string) => {
  const query = useQuery({
    queryKey: adminChallengeQueryKey(slug),
    enabled: !!slug,
    queryFn: async () => {
      const request: ChallengeService.ListChallengesRequest = {
        filter: { slug, includeDeleted: true },
        limit: 1,
        offset: 0,
      }
      // Use the admin-only listChallenges (slug is an exact-match filter) rather than
      // getChallengeBySlug — the latter is scoped to the calling user's own challenge,
      // enforces the submission window, and boots SQL. Admins must view any user's challenge.
      const response = await apis.challengeService.listChallenges(request)
      return response.data
    },
  })

  return {
    challengeInfo: query.data ? selectFirstChallenge(query.data) : undefined,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    notFound: query.isSuccess && query.data.length === 0,
    refetch: query.refetch,
  }
}
